module.exports = __webpack_public_path__ + "img/jtjkzxt.dd692009.jpg";